import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { apiRequest } from "../api/client";

const SUBTITLE =
  "Contrary to popular belief, Lorem Ipsum is not simply random text";

function FAQ({ onOpenAuth, onOpenMenu }) {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function fetchFaqs() {
      setLoading(true);
      setError("");
      try {
        const res = await apiRequest("api/faqs", { method: "GET" });
        if (cancelled) return;
        if (res.ok && Array.isArray(res.data)) {
          const sorted = [...res.data].sort(
            (a, b) => (a.position ?? 0) - (b.position ?? 0)
          );
          setFaqs(sorted);
          if (sorted.length > 0) setOpenId(sorted[0].id);
        } else {
          setError(res.data?.message || "Failed to load FAQs.");
        }
      } catch (err) {
        if (!cancelled) setError("Failed to load FAQs.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    fetchFaqs();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900 flex flex-col">
      <Header onOpenAuth={onOpenAuth} onOpenMenu={onOpenMenu} />

      <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-10 md:px-6">
        <section className="text-center mb-8">
          <h1 className="text-2xl font-bold text-slate-900 md:text-3xl">
            Frequently Asked Questions
          </h1>
          <p className="mt-2 text-sm text-slate-500">{SUBTITLE}</p>
        </section>

        <div className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
          {loading && (
            <div className="flex justify-center py-12">
              <span className="text-sm text-slate-500">Loading…</span>
            </div>
          )}

          {error && (
            <div className="py-8 text-center">
              <p className="text-sm text-red-600">{error}</p>
            </div>
          )}

          {!loading && !error && faqs.length === 0 && (
            <div className="py-12 text-center text-sm text-slate-500">
              No FAQs available.
            </div>
          )}

          {!loading && !error && faqs.length > 0 && (
            <div className="divide-y divide-slate-200">
              {faqs.map((faq) => {
                const isOpen = openId === faq.id;
                return (
                  <div key={faq.id} className="border-slate-200">
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : faq.id)}
                      className="flex w-full items-center justify-between gap-4 px-6 py-4 text-left hover:bg-slate-50 transition-colors"
                    >
                      <span className="text-sm font-semibold text-slate-900">
                        {faq.question}
                      </span>
                      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded border border-slate-300 bg-white text-slate-600">
                        {isOpen ? (
                          <svg
                            viewBox="0 0 24 24"
                            className="h-4 w-4"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M5 12h14" />
                          </svg>
                        ) : (
                          <svg
                            viewBox="0 0 24 24"
                            className="h-4 w-4"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M12 5v14" />
                            <path d="M5 12h14" />
                          </svg>
                        )}
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-6 pb-4 pt-0">
                        <p
      className="text-sm text-slate-600 leading-relaxed"
      dangerouslySetInnerHTML={{ __html: faq.answer }}
    />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default FAQ;
